export default "__VITE_ASSET__BfIO$EJo__"